<script setup lang="ts">
import {useNewsStore} from '~/stores/newsStore';
import {removeTags} from "~/utils/stringTools";

const config = useRuntimeConfig();

const route = useRoute()

let {data}: any = await useFetch(() => `${config.public.baseUrlBackend}/api/news/${route.params.slug}`,
    {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
        },
    }
);
let items = data
let newSelected = null;
const itemsPerPage = 5;
const currentPage = ref(1);
let itemsNews = ref<any[]>([])
let itemsBanners = ref<any[]>([])
let imageSelected = ref(items.value?.thumbnail);
const currentImageIndex = ref(-1);
let breadcrumbs: any = [
    {url: '/', name: 'Uno'},
    {url: '/noticias', name: 'Notícias'},
    {url: '/noticias', name: route.params.slug},

];
if (data.value != null) {
    newSelected = data.value.title;
    breadcrumbs = [
        {url: '/', name: 'Uno'},
        {url: '/noticias', name: 'Notícias'},
        {url: '/noticias', name: data.value.title},

    ];
}

const totalPages = computed(() => {
    return Math.ceil(items.value.libraryImage.length / itemsPerPage);
});

const changeNew = async () => {
    const currentNew = useNewsStore()
    itemsNews.value = currentNew.getNew() ?? [];
    itemsBanners.value = currentNew.getBanners() ?? [];
}

const paginatedImages: any = computed(() => {
    if (items.value.libraryImage) {
        let images = [...items.value.libraryImage];
        const start = (currentPage.value - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        return images.slice(start, end);
    } else {
        return [];
    }
});

onMounted(changeNew);

const title = ref(newSelected)
useHead({
    title,
    meta: [
        {
            name: 'description',
            content: `${removeTags(data.value?.text).substring(0, 200)}...`
        },
        // OGP
        {
            name: 'og:title',
            content: data.value?.title
        },
        {
            name: 'og:description',
            content: `${removeTags(data.value?.text).substring(0, 200)}...`
        },
        {
            name: 'og:image',
            content: data.value?.thumbnail
        },
        {
            name: 'og:url',
            content: window.location.href
        },
    ]
})

const selectedImage = (img: string) => {
    imageSelected.value = img;
    currentImageIndex.value = items.value.libraryImage.findIndex((i: any) => i === img);
};

function previousImage() {

    if (currentImageIndex.value === -1 || (currentImageIndex.value === 0 && currentPage.value === 1)) {
        currentPage.value = totalPages.value;
        currentImageIndex.value = items.value.libraryImage.length % itemsPerPage - 1;
        if (currentImageIndex.value < 0) {
            currentImageIndex.value = itemsPerPage - 1;
        }
        imageSelected.value = items.value.libraryImage[currentImageIndex.value + (currentPage.value - 1) * itemsPerPage];
    } else if (currentImageIndex.value > 0) {

        currentImageIndex.value--;
        imageSelected.value = items.value.libraryImage[currentImageIndex.value + (currentPage.value - 1) * itemsPerPage];
    } else {

        currentPage.value--;
        currentImageIndex.value = itemsPerPage - 1;
        imageSelected.value = items.value.libraryImage[currentImageIndex.value + (currentPage.value - 1) * itemsPerPage];
    }
}


function nextImage() {
    if (currentPage.value === totalPages.value && currentImageIndex.value === items.value.libraryImage.length - 1 - (currentPage.value - 1) * itemsPerPage) {

        currentPage.value = 1;
        currentImageIndex.value = -1;
        imageSelected.value = items.value.thumbnail;
    } else if (currentImageIndex.value === -1) {

        currentImageIndex.value = 0;
        imageSelected.value = paginatedImages.value[currentImageIndex.value];
    } else {

        let globalIndex = (currentPage.value - 1) * itemsPerPage + currentImageIndex.value + 1;
        if (globalIndex >= items.value.libraryImage.length) {

            currentPage.value = 1;
            currentImageIndex.value = -1;
            imageSelected.value = items.value.thumbnail;
        } else {

            currentImageIndex.value = globalIndex % itemsPerPage;
            currentPage.value = Math.floor(globalIndex / itemsPerPage) + 1;
            imageSelected.value = items.value.libraryImage[globalIndex];
        }
    }
}

</script>

<template>
    <template v-if="items">
        <div class="flex items-center justify-center w-full px-6 pt-5 pb-12 lg:px-60 lg:pt-12">
            <div class="pt-2 rounded-md lg:w-[910px] w-auto mx-auto">
                <Breadcrumbs :attr="{ attr: breadcrumbs }"></Breadcrumbs>

                <p class="mt-4 mb-4 text-sm lg:text-4xl font-bold text-color-primary lg:w-[910px]">
                    {{ items.subtitle }}
                </p>

                <div class="lg:max-w-[910px] w-full h-full">
                    <img
                        class="w-full h-auto object-cover lg:w-[908px] lg:h-[591px] mx-auto"
                        :src="imageSelected"
                        :alt="items.title"
                    >

                    <div
                        v-if="paginatedImages.length > 0"
                        class="flex items-center justify-center gap-3 lg:gap-[13px] lg:w-[908px] pr-6 transition duration-700 ease-in-out delay-150"
                    >
                        <img
                            class="w-6 h-6 ml-4 mr-4 cursor-pointer"
                            alt="icon do botão de ação"
                            @click="previousImage"
                            src="/assets/icons/arrow-circle-left.png"
                        />

                        <div v-for="img in paginatedImages" :key="img">
                            <img
                                class="cursor-pointer w-[171px] h-auto lg:h-[132px] mt-2 mx-auto"
                                :src="img"
                                alt="listagem de imagens" @click="selectedImage(img)"
                            />
                            <p :class="{ 'bg-color-primary h-1': img === imageSelected }"></p>
                        </div>

                        <img
                            class="w-6 h-6 ml-4 cursor-pointer lg:mr-4 text-color-primary"
                            alt="icon do botão de ação"
                            @click="nextImage"
                            src="/assets/icons/arrow-circle-right.png"
                        />
                    </div>

                </div>

                <div class="px-10 pt-10 lg:max-w-[910px] h-auto overflow-auto text-container" v-html="items.text"></div>

                <div class="w-auto pt-10 pl-10 lg:w-full">
                    <ShareIcons :attr="[items.tag, items.subtitle]"/>
                </div>
            </div>
        </div>

        <div>
            <CarouselMedium :attr="itemsBanners"></CarouselMedium>
        </div>

        <div class="bg-[#E8E9E8] mt-5 pt-3 pb-[10px]">
            <div class="mt-3 mb-3 text-center">
                <a class="text-4xl font-bold text-color-primary">Leia também:</a>
            </div>
            <div class="
                    grid grid-container justify-items-center space-y-6
                    sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4
                    xl:px-20 lg:mt-6
                 ">
                <News :attr="{quantity: 4, tags: 'Geral'}" />
            </div>
        </div>
    </template>
    <template v-else>
        <div class="flex justify-center w-full">
            <Card404/>
        </div>
    </template>
    <FooterFull class="w-full"/>
</template>

<style>
.flex div {
    max-width: 1920px;
}

.text-container {
    color: #0400a1;
}

.text-container p img {
    margin: 16px !important;
}

.text-container h1,.text-container .page-title {
    font-size: 25px;
    line-height: 30px;
    font-weight: normal
}

.text-container h2 {
    font-size: 24px;
    line-height: 30px;
    font-weight: normal
}

.text-container h3 {
    font-size: 20px;
    line-height: 26px;
    font-weight: normal
}

.text-container p,.text-container h5,.text-container span {
    font-size: 16px;
    margin: 0 0 16px;
    line-height: 26px
}

.text-container hr {
    border-left: none
}

.text-container em {
    font-style: italic;
    font-family: 'Open Sans Italic', 'Open Sans',"Arial","Helvetica"
}

.text-container a {
    color: #1976D2;
    text-decoration: none
}

.text-container a:hover {
    color: #24A7FF
}

.text-container img {
    height: auto
}

.text-container strong,.text-container b {
    font-weight: 600
}

.text-container figure {
    display: table
}

.text-container figure img {
    display: table-row;
    max-width: 100%
}

.text-container figure figcaption {
    padding: 4px 0;
    display: block;
    text-align: center
}

.text-container blockquote {
    border-left: solid 2px #24A7FF;
    margin: 0 0 16px !important
}

@media (min-width: 992px) {
    .text-container blockquote {
        margin-left:32px !important
    }
}

.text-container blockquote p {
    text-indent: 0 !important;
    margin: 0 !important;
    padding-left: 30px;
    color: #24A7FF;
    font-style: italic
}
</style>
